<template>
  <div>
    <div class="container p-3 mb-5 bg-white rounded">
      <p class="p-0 m-0 text-dark">4. Waar staat uw woning?</p>
    </div>
    <!-- ans -->
    <div class="fade-in">
      <div class="container">
        <div class="mb-4 text-center" @click="moveToNextStep">
          <p>Bedankt voor je antwoord.</p>
        </div>
      </div>
      <div class="text-center mt-5">
        <b-button variant="light" size="md" @click="moveToNextStep">
          Volgende vraag »
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Step1Ans",
  methods: {
    moveToNextStep() {
      this.$emit("next");
    },
  },
};
</script>

<style></style>
